import { PureComponent } from 'preact-compat'

import { unlike, like } from '../services/topicService'

/* eslint-disable import/no-internal-modules */
import { ContentType } from '@insided/shared/utils/contentType'

export interface LikeProps {
  topicId: number
  contentType: ContentType
  likedBy: string[]
  likes: number
  onChangeLike: (likes: number, likedBy: string[]) => void
  userId?: string
}

class Like extends PureComponent<LikeProps> {
  constructor (props: LikeProps) {
    super(props)
    this.likeTopic = this.likeTopic.bind(this)
    this.unlikeTopic = this.unlikeTopic.bind(this)
  }

  async likeTopic () {
    const { contentType, topicId, likedBy, userId, onChangeLike } = this.props
    await like(contentType, topicId, Number(userId))
    const newLikedBy = [...likedBy]
    newLikedBy.push(String(userId))
    onChangeLike(newLikedBy.length, newLikedBy)
  }

  async unlikeTopic () {
    const { contentType, topicId, likedBy, userId, onChangeLike } = this.props
    await unlike(contentType, topicId, Number(userId))
    const newLikedBy = [...likedBy].filter(item => item !== userId)
    onChangeLike(newLikedBy.length, newLikedBy)
  }

  render () {
    const { likes, likedBy, userId } = this.props
    const userHasLiked = likedBy?.includes(String(userId))
    return (
      <div className='post--options-list-container-item'>
        <a data-qa='like-topic' className={userHasLiked ? 'active' : ''} onClick={userHasLiked ? this.unlikeTopic : this.likeTopic}>
          <i className='fa fa-thumbs-up' /> Like ({likes})
        </a>
      </div>
    )
  }
}

export default Like
